import { Controller } from "@hotwired/stimulus"

// The request page's side panel (home, Key Data, approve, link, email): a
// sheet parked off the right edge with a pull tab that slides it in and out.
// Not modal, so the document stays usable beside it; Escape and the X close
// it. Whether it is open is kept for the tab's session, so the page an
// approve or email redirects back to opens it again where the reader left
// it. The memory is per request (the key value), so a panel opened on one
// request does not open itself over the next. Everything but the tab is
// inert while parked, so Tab never reaches hidden controls.
export default class extends Controller {
  static targets = ["panel", "tab", "body"]
  static values = { key: String }

  connect() {
    this.onKeydown = (event) => {
      if (event.key === "Escape" && this.isOpen) this.close()
    }
    window.addEventListener("keydown", this.onKeydown)
    if (this.stored === "open") this.show(true)
  }

  disconnect() {
    window.removeEventListener("keydown", this.onKeydown)
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.show(true)
    this.stored = "open"
  }

  close() {
    this.show(false)
    this.stored = "closed"
    this.tabTarget.focus()
  }

  show(open) {
    this.isOpen = open
    this.panelTarget.classList.toggle("translate-x-full", !open)
    this.tabTarget.setAttribute("aria-expanded", String(open))
    this.bodyTarget.inert = !open
  }

  // Storage can be missing or refuse (a private window, blocked site data);
  // the panel then simply starts parked.
  get storageKey() {
    return `desk-side-panel-${this.keyValue}`
  }

  get stored() {
    try { return sessionStorage.getItem(this.storageKey) } catch { return null }
  }

  set stored(value) {
    try { sessionStorage.setItem(this.storageKey, value) } catch { /* storage unavailable */ }
  }
}
